import { configureStore } from "@reduxjs/toolkit";
import orderReducer from "../REDUX/orderSlice"
const store = configureStore({
  reducer: orderReducer,
})
export default store;
